/* istanbul ignore file */
import { Button, Card, TearDivider } from '@distribusion/owl-frontend-ui'
import React, { ReactElement, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import BlockSection from '@components/Blocks/common/BlockSection'
import useIsMobile from '@hooks/useIsMobile'
import useSearchParams from '@hooks/useSearchParams'
import bem from '@lib/bem'
import { useTranslation } from '@lib/i18n'
import url from '@lib/url'
import { MonthPicker } from '@ui'

import '@components/Blocks/Subscription/index.scss'

type SubscriptionBlockProps = PageBlocks.BlockComponentProps<PageBlocks.SubscriptionBlock>

const SubscriptionHeader = ({ title }: { title: string }) => (
  <div className={bem('subscription-card', 'header')}>
    <h3>{title}</h3>
  </div>
)

const SubscriptionBlock = (props: SubscriptionBlockProps): ReactElement => {
  const { translationKey, ...rest } = props
  const [selectedMonth, setSelectedMonth] = useState<string | null>(null)
  const [searchParams] = useSearchParams()
  const isMobile = useIsMobile()
  const navigate = useNavigate()
  const { t } = useTranslation()

  const { title, description, button, introTitle, introSubtitle } = t<
    any,
    PageBlocks.CardTranslation & PageBlocks.IntroTranslation
  >(`customBlocks.${translationKey}`, {
    returnObjects: true,
    defaultValue: {},
  })

  const handleMonthSelect = (value: string) => {
    setSelectedMonth(value)
  }

  const handleRedirect = () => {
    const params = {
      ...searchParams,
      subscriptionStart: selectedMonth,
    }

    navigate(url.build(['/', 'subscription'], params))
  }

  return (
    <BlockSection {...rest}>
      <div className="row column-sm">
        <div className="subscription-card order-sm-2">
          <Card
            header={<SubscriptionHeader title={title || ''} />}
            body={
              <div className="px-6">
                <MonthPicker
                  selectedMonth={selectedMonth}
                  onMonthSelect={handleMonthSelect}
                  label={description || ''}
                />
              </div>
            }
          />
          <TearDivider />
          <div className={bem('subscription-card', 'footer')}>
            <Button variant="filled" color="primary" onClick={handleRedirect}>
              <div className="button-content">
                <span>{button}</span>
                {/* Price will be fetched from GET products as described here:
              https://distribusion.atlassian.net/wiki/spaces/PLAT/pages/1674149889/
              Subscription+Service#FR-02-%7C-Subscription-sales */}
                <span>{'€ 58'}</span>
              </div>
            </Button>
          </div>
        </div>
        <div className="subscription-intro column order-sm-1 mb-sm-5">
          <h1 className={bem('subscription-intro', 'title')}>{introTitle}</h1>
          {!isMobile && <span className={bem('subscription-intro', 'subtitle')}>{introSubtitle}</span>}
        </div>
      </div>
    </BlockSection>
  )
}

export default SubscriptionBlock
